import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { ButtonEditInline } from 'Components/Buttons/ButtonEditInline'
import { DocumentationTableWrapper } from 'Components/Settings/Documentation/DocumentationTableWrapper'
import { DocumentationWrapper } from 'Components/Settings/Documentation/DocumentationWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import FilteredTable from 'Containers/FilteredTable'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { getCountries } from 'Reducers/Countries/actions'
import { getDocumentTypes } from 'Reducers/Document/actions'
import { PATHS } from 'Config/Routing/paths'
import SettingsIcon from 'Assets/Images/icons/settings'
import SubmitButton from 'Components/Form/SubmitButton'
import { StatusLabel } from 'Components/StatusLabel'

class Documentation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      documentAddModalShow: false,
      documentEditModalShow: false,
      documentationTableColumns: [
        {
          accessor: 'name',
          label: 'Name',
          name: 'name',
          sortable: true,
        },
        {
          accessor: 'instructionText',
          label: 'Instruction',
          name: 'instructionText',
          sortable: true,
        },
        {
          accessor: 'active',
          label: 'Status',
          name: 'status',
          sortable: true,
          render: active => {
            return <StatusLabel status={active ? 'active' : 'archived'} />
          },
        },
        {
          accessor: 'countryCode',
          label: 'Country code',
          name: 'countryCode',
          sortable: true,
          render: value => (value ? value : 'ALL'),
        },
        {
          type: 'actions',
          name: 'actions',
          label: 'Actions',
          accessor: 'id',
          render: id => (
            <div className="actions-cell">
              <ButtonEditInline
                onClickHandler={() => this.documentationEditHandler(id)}
              />
            </div>
          ),
        },
      ],
    }

    this.documentationAddHandler = this.documentationAddHandler.bind(this)
    this.documentationEditHandler = this.documentationEditHandler.bind(this)
    this.getCountryFilterOptions = this.getCountryFilterOptions.bind(this)
  }

  componentDidMount() {
    const { getCountries, getDocumentTypes } = this.props

    getCountries()
    getDocumentTypes()
  }

  render() {
    return (
      <DocumentationWrapper>
        <LayoutDashboard>
          {this.renderBreadcrumbs()}
          <PageTitle>Signup Identification Documents</PageTitle>
          <p style={{ marginBottom: '30px' }}>
            When signing up, users must take photographic evidence of each
            specified identification document for their application to be
            considered. Each country may have their own requirements.
          </p>
        </LayoutDashboard>
        {this.renderDocumentationTable()}
      </DocumentationWrapper>
    )
  }

  renderBreadcrumbs() {
    const currentPath = this.props.match.url

    return (
      <div>
        <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
        <Breadcrumb
          data={{
            title: 'Settings',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
          }}
        />
        <Breadcrumb
          data={{
            title: 'Signup Identification Documents',
            pathname: currentPath,
          }}
        />
      </div>
    )
  }

  renderDocumentationTable() {
    const { documentTypesList } = this.props
    const { documentationTableColumns } = this.state

    return (
      <DocumentationTableWrapper>
        <SubmitButton
          value="Add document"
          onClick={this.documentationAddHandler}
        />
        <br />
        <HideWhenBlocked>
          <FilteredTable
            columns={documentationTableColumns}
            data={documentTypesList.sort((a, b) => b.active - a.active)}
            filters={this.getFilters()}
            showSearchFilter={false}
          />
        </HideWhenBlocked>
      </DocumentationTableWrapper>
    )
  }

  documentationAddHandler() {
    const { history } = this.props

    history.push(`${this.props.match.url}/create`)
  }

  documentationEditHandler(id) {
    const { history } = this.props

    history.push(`${this.props.match.url}/${id}/edit`)
  }

  getCountryFilterOptions() {
    const { countries } = this.props

    return countries.map(country => country.code)
  }

  getFilters() {
    const filters = [
      {
        columnName: 'countryCode',
        label: 'Country',
        noValueLabel: 'All',
        options: this.getCountryFilterOptions(),
        sorted: true,
      },
    ]

    return filters
  }
}

Documentation.propTypes = {
  countries: PropTypes.array.isRequired,
  documentTypesList: PropTypes.array.isRequired,
  getCountries: PropTypes.func.isRequired,
  getDocumentTypes: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  countries: state.countries.countriesList,
  documentTypesList: state.document.documentTypesList,
})

const mapDispatchToProps = dispatch => ({
  getCountries: () => dispatch(getCountries()),
  getDocumentTypes: () => dispatch(getDocumentTypes()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Documentation))



// WEBPACK FOOTER //
// ./src/Containers/Settings/Documentation/index.js